import SubscriptionRepository from './repositories/subscription.repository';

/**
 * Subscription Service
 * Business logic for subscription management
 */
const SubscriptionService = {
  /**
   * Get current subscription
   * @returns {Promise<Object>}
   */
  getCurrent: async () => {
    return await SubscriptionRepository.getCurrent();
  },

  /**
   * Get my features (based on current subscription)
   * @returns {Promise<Object>}
   */
  getMyFeatures: async () => {
    return await SubscriptionRepository.getMyFeatures();
  },

  /**
   * Check access to a specific feature
   * @param {string} featureName - Feature name to check
   * @returns {Promise<Object>}
   */
  checkAccess: async (featureName) => {
    return await SubscriptionRepository.checkAccess(featureName);
  },
};

export default SubscriptionService;

